import { createFileRoute } from '@tanstack/react-router'
import { getTenantConfig } from '@/lib/tenant-config'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@lead-magnifier/ui'
import { Key, Construction } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/api-keys/')({
  component: ApiKeysPage,
})

function ApiKeysPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">API Keys</h1>
        <p className="text-muted-foreground mt-1">
          Verwalte API-Schlüssel für externe Integrationen
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Construction className="h-5 w-5" />
            Demnächst verfügbar
          </CardTitle>
          <CardDescription>
            Dieses Feature befindet sich noch in Entwicklung
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col items-center justify-center py-12 text-center">
            <Key className="h-16 w-16 text-muted-foreground/50 mb-4" />
            <h3 className="text-lg font-medium mb-2">API-Zugang</h3>
            <p className="text-sm text-muted-foreground max-w-md">
              Bald kannst du API-Schlüssel erstellen, um {getTenantConfig().branding.name} mit
              deinem CRM, Newsletter-Tool oder anderen Systemen zu verbinden.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
